export default class StateUtil{
    constructor(state) {
        this._state = state;
    }

    _state = null;

    getBoxesSelected() {
        //Modificando para adaptação de remoção dos boxes em states
        if(this._state.boxes.value != undefined) {
            return this._state.boxes.value.filter(b => b.state.selected);
        }
        return this._state.boxes.filter(b => b.state.selected);
    };

    getFirstSelected() {
        if(this._state.boxes.value != undefined){
            return this._state.boxes.value.find(b => b.state.first)
        }
        return this._state.boxes.find(b => b.state.first)
    };

    getBoxesCtrlC() {
        if(this._state.boxes.value != undefined) {
            return this._state.boxes.value.filter(b => b.state.copied)
        }
        return this._state.boxes.filter(b => b.state.copied)
    };

    getBoxesCtrlX() {
        if(this._state.boxes.value != undefined) {
            return this._state.boxes.value.filter(b => b.state.cut)
        }
        return this._state.boxes.filter(b => b.state.cut)

    };

    calcVirtualBound() {
        let selected = this.getBoxesSelected();

        if (selected.length) {
            let menorX = 50000000000,
                maiorX = 0,
                menorY = 50000000000,
                maiorY = 0;

            selected.forEach(b => {
                menorX = Math.min(menorX, b.pixel.x);
                menorY = Math.min(menorY, b.pixel.y);

                maiorX = Math.max(maiorX, b.pixel.x + b.pixel.w);
                maiorY = Math.max(maiorY, b.pixel.y + b.pixel.h);
            });

            //console.log('>>>> calculou bound')

            this._state.boxSelectedBound.value = {
                x1: menorX,
                x2: maiorX,

                y1: menorY,
                y2: maiorY
            }
            return;
        }
        this._state.boxSelectedBound.value = null;
    };

    setIdx(box, newIdx, profundidade, ignoreFilhos) {
        profundidade = ~~(profundidade) || 1;
        ignoreFilhos = ignoreFilhos || false;

        //reorganiza os filhos pro novo idx, idenpendente de aba
        if (!ignoreFilhos) {
            let filhos = this.getBoxesFilhosDiretos(box.id);

            let idxFilho = newIdx;
            filhos.forEach(b => {
                idxFilho += 0.0001;
                this.setIdx(b, idxFilho, this._state.boxes.value, profundidade+1)
            })
        }

        //muda o idx
        box.idx = newIdx;        

        //reorganiza informação dos pais
        this._state.boxes.value
            .filter(b => b.parent.id != null)
            .forEach(b => {
                b.parent.idx = this._state.boxes.value.filter(gb => gb.id == b.parent.id)[0].idx
            });
    };

    ordenaBoxes() {
        //console.log('ordenando', console.trace())
        return this._state.boxes.value.sort(function(a, b) {
            return (a.idx > b.idx) ? 1 : ((a.idx < b.idx) ? -1 : 0);
        });
    };

    sequenciaBoxesIdx() {
        this._state.boxes.value.forEach((b, i) => {
            this._state.boxes.value.filter(bx => bx.parent.idx == b.idx).forEach(bx => bx.parent.idx = i);
            b.idx = i;
        })
    };

    //filhos do mesmo nivel
    getBoxesFilhosDiretos(idParent, idxTab) {
        if (idxTab != undefined)
            return this._state.boxes.value.filter(b => b.parent.id == idParent && b.parent.idxTab == idxTab)

        return this._state.boxes.value.filter(b => b.parent.id == idParent)
    };

    //toda a linhagem dos filhos
    getBoxesFilhos(idxInicial) {
        let filhos = new Set();

        let _this = this;
        //funcao recursiva
        function IdentificaRecursivamenteTodosFilhos(indexInicial) {
            let idxPai = indexInicial;

            if (indexInicial != -1) {
                filhos.add(indexInicial);
                idxPai = _this._state.boxes.value[indexInicial].idx;
            }

            //procurafilhos
            _this._state.boxes.value.filter(b => b.parent.idx == idxPai).forEach(
                f => IdentificaRecursivamenteTodosFilhos(f.idx)
            )
        }

        IdentificaRecursivamenteTodosFilhos(idxInicial);

        filhos = [...filhos]; //trnsforma o Set em Array

        var result = [];
        filhos.forEach(f => {
            result.push({
                idx: f,
                idxPai: this._state.boxes.value[f].parent.idx,
                idxTabPai: this._state.boxes.value[f].parent.idxTab,
                id: this._state.boxes.value[f].id,
            })
        });

        return result;
    }
}